"use client"

import { Alert, AlertIcon, AlertTitle, AlertDescription, Box, Text } from "@chakra-ui/react"

import { radius } from "../../theme/tokens"

/**
 * Shown in place of a report page when the signed-in account holds NO supplier
 * at all — an organisation admin created before its organisation has any
 * supplier (2026-09-16: org first, suppliers after). Rendered by
 * AuthenticatedLayout for /sales, /insights, /strike, /ranging and /margin,
 * so the page itself never mounts: the report components assume a selected
 * supplier and crash on an empty response (Top10A/B `.map` of undefined).
 *
 * The account is otherwise fully usable — Users, Articles and Batch Reports
 * still open — and the first supplier created in the organisation is granted
 * to it (and becomes its default) automatically.
 */
const NoSupplierNotice = ({ pageTitle }) => {
  let orgName = null
  try {
    orgName = localStorage.getItem("user_org_name")
  } catch (e) {
    orgName = null
  }

  return (
    <Alert
      status="info"
      variant="subtle"
      flexDirection="column"
      alignItems="center"
      textAlign="center"
      py={10}
      borderRadius={radius.md}
      data-testid="no-supplier-notice"
    >
      <AlertIcon boxSize="32px" mr={0} />
      <AlertTitle mt={3} mb={1} fontSize="lg">
        No suppliers yet
      </AlertTitle>
      <AlertDescription maxWidth="md">
        <Text>
          The {pageTitle || "report"} opens once {orgName ? `${orgName} has` : "your account has"} a supplier.
        </Text>
        <Box mt={2} fontSize="sm" opacity={0.85}>
          Suppliers are added by Spear Management and appear here automatically.
        </Box>
      </AlertDescription>
    </Alert>
  )
}

export default NoSupplierNotice
